export const calcFillerWidth = (containerWidth, columns) => {
  const width = containerWidth - columns.width;

  if (width > 150) {
    return width;
  }

  return 150;
};
